import { get } from "@services/apiService.js";

export default {
  getAlbumCategories(lang) {
    return get(`/v4/album-manager/v1/categories`, {language : lang})
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getAlbumCategoriesHasAlbums(lang) {
    return get(`/v4/album-manager/v1/categoryHasAlbums`, {language : lang})
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getAlbumList(options = {}) {
    return get(`/v4/album-manager/v1/albums/list`, options)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getAlbumListAll(options = {}) {
    return get(`/v4/album-manager/v1/albums`, options)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getAlbumDetail(options = {}){    
    return get(`/v4/album-web/v1/albums/${options.albumID}`, options)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getAlbums(options = {}) {
    return get(`/v4/album-web/v1/albums`, options)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  }
}